export default "__VITE_ASSET__Dah_3fL5__"